import React, { useState, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import companyService from 'src/services/company.service'

export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value])

  return debouncedValue
}

export const useQuery = () => {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

export function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false)

  const observer = useMemo(() => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)), [])

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [ref.current])

  return isIntersecting
}
export function usePhoneNumberOptions(isDeepFake) {
  const [phoneNumbersOptions, setPhoneNumbersOptions] = useState([])

  useEffect(() => {
    companyService.getCompanyPhones(isDeepFake).then(resp => {
      setPhoneNumbersOptions(resp.data.map(el => ({ ...el, name: el.formattedPhoneNumber, value: el.phoneNumber })))
    })
  }, [])

  return phoneNumbersOptions
}
